/* ergono, warstwa interakcji.
   Bez frameworka i bez zaleznosci. Kazdy modul montuje sie sam,
   jesli znajdzie swoj element, i milczy, jesli go nie ma. */

(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat("pl-PL", {
        style: "currency", currency: currency || "PLN", minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace(".", ",") + " z\u0142";
    }
  }

  // Adres z CDN Shopify bez parametru width oddaje oryginal, przy zmianie
  // wariantu potrafi to byc kilka MB. Doklejamy zadana szerokosc.
  function sized(src, w) {
    if (!src || /[?&]width=/.test(src)) return src;
    return src + (src.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* Licznik w naglowku jest w kilku miejscach naraz (pasek gorny, szuflada). */
  function paintCount(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function (node) {
      node.textContent = n;
      // Krazek z liczba znika przy pustym koszyku: pusty znaczek przy ikonie
      // wyglada jak niedomkniety stan, a nie jak informacja.
      node.hidden = !n;
    });
    document.querySelectorAll("[data-cart-link]").forEach(function (link) {
      link.setAttribute("aria-label", (link.dataset.tCart || "") + " (" + n + ")");
    });
  }

  /* ---------- hero: film prowadzony przewijaniem ----------
     Film klienta jest tu bohaterem pierwszego ekranu. Na szerokim ekranie
     jego GLOWICA jedzie za przewijaniem, a nad nim zmieniaja sie podpisy
     dopasowane do aktow materialu: calosc, wychylenie, podstawa, tkanina.

     TRZY RZECZY, KTORE TEN MODUL MUSI ZROBIC DOBRZE:

     1. DOBRAC PLIK DO EKRANU, zanim przegladarka dociagnie cokolwiek poza
        naglowkiem. W znaczniku siedzi wersja szeroka, bo jest poprawna na
        kazdej szerokosci; tutaj schodzi na kadr pionowy w dloni albo wchodzi
        na wersje z klatka kluczowa co cztery. Bez gestych klatek glowica
        szarpie, a plik do przewijania wazy piec razy tyle co petla i nigdy
        nie ma prawa trafic na telefon.

     2. NIE UKRYC NICZEGO, DOPOKI NIE JEST PEWNE, ZE KTOS TO PODNIESIE.
        Uklad aktu wlacza dopiero klasa `is-akt`, dokladana TUTAJ, po udanym
        montazu. Bez skryptu, przy ograniczeniu ruchu i w waskim oknie hero
        zostaje zwyklym stosem, w ktorym widac wszystko naraz.

     3. LICZYC STAN SYNCHRONICZNIE, w zdarzeniu przewijania, a nie w petli
        klatek. Klatek nie ma w karcie w tle, przy oszczedzaniu energii i w
        rendererze bez kompozytora, a postep jest czysta funkcja pozycji
        przewijania i nie ma czego wygladzac.                                */
  /* Wysokosc tego, co stoi NAD heroem (pasek obietnic plus naglowek).
     Hero ma ujemny margines gorny o te wartosc i o nia samą powieksza swoje
     wypelnienie od gory, wiec film jest tlem calego ekranu, a pismo i tak
     zaczyna sie pod paskiem. Mierzone, a nie zakladane: pasek obietnic
     potrafi zawinac sie na dwa wiersze na waskim telefonie. */
  function initTop() {
    var hdr = document.querySelector(".hdr");
    if (!hdr) return;

    /* SUMA CALEGO LANCUCHA offsetParent, a nie samo offsetTop.

       Dwa warunki naraz i kazdy wyklucza inne rozwiazanie:
       1. getBoundingClientRect odpada, bo naglowek jest LEPKI: po przewinieciu
          jego prostokat siedzi przy zerze i pomiar klamie o cala wysokosc
          paska obietnic;
       2. samo offsetTop odpada, bo Shopify owija kazda sekcje we wlasny
          <div>, a base.css daje kazdemu takiemu opakowaniu position:relative.
          Opakowanie jest wiec offsetParentem naglowka i offsetTop wynosi
          w nim ZERO zamiast wysokosci paska obietnic.

       Skutek bledu byl widoczny i kosztowal zgloszenie: --top-h wychodzilo
       80 px zamiast 118, hero podciagalo sie o 38 px za malo, a ze ma
       wysokosc 100svh, jego dolna krawedz razem z cena i przyciskiem
       schodzila 38 px PONIZEJ krawedzi pierwszego ekranu. W makiecie tego
       nie bylo widac, dopoki render.mjs nie zaczal emitowac opakowan sekcji.

       Suma offsetTop po lancuchu offsetParent daje odleglosc od gory
       dokumentu i jest odporna na oba te przypadki. */
    function docTop(el) {
      var y = 0;
      while (el) { y += el.offsetTop; el = el.offsetParent; }
      return y;
    }
    function set() {
      var h = docTop(hdr) + hdr.offsetHeight;
      if (h > 0) document.documentElement.style.setProperty("--top-h", h + "px");
    }
    set();
    window.addEventListener("resize", set, { passive: true });
    if ("ResizeObserver" in window) new ResizeObserver(set).observe(hdr);
  }

  /* ---------- hero ----------
     TRYB PRZELICZA SIE PRZY KAZDEJ ZMIANIE PROGU, a nie raz przy starcie,
     i to jest naprawa bledu zgloszonego przez klienta 18.09.2026: „przez
     jakis czas jak zmienilem z desktopa na mobile to nadal mialem ten film,
     dopiero potem wskoczyl gif", a po powrocie na desktop „nadal byl gif".

     Tak wlasnie bylo. Stara wersja czytala matchMedia JEDEN RAZ, podmieniala
     zrodlo i konczyla prace. Zmiana szerokosci okna (przelacznik urzadzenia
     w narzedziach, obrot telefonu, zwykle rozciagniecie okna) nie ruszala
     ani pliku, ani klasy .is-akt, wiec:
     - z biurka w dlon zostawal ciezki film poziomy, dopoki ktos nie odswiezyl;
     - z dloni na biurko zostawala kwadratowa petla, w dodatku BEZ aktu, wiec
       wszystkie hasla staly stosem w lewej kolumnie zamiast zmieniac sie
       przy przewijaniu.

     Teraz stan liczy `apply()` i wola go zdarzenie `change` z matchMedia.
     Nasluchy przewijania i obserwator widocznosci sa zakladane RAZ i same
     sprawdzaja tryb: przepinanie ich przy kazdej zmianie progu jest
     najprostszym sposobem na to, zeby ktorys zostal podpiety dwa razy.   */
  function initHero(sec) {
    var film = sec.querySelector("[data-hero-film]");
    var cues = Array.prototype.slice.call(sec.querySelectorAll("[data-cue]"));
    if (!film) return;

    var mq = window.matchMedia("(min-width: 900px)");
    var tryb = "";        // "akt" | "film" | "petla"
    var zalozone = "";    // ostatnio ustawione zrodlo, zeby nie ladowac go dwa razy
    var moved = false;

    /* OKNA PODPISOW NIE MOGA NA SIEBIE ZACHODZIC. Przy przenikaniu zdjec
       zakladka jest zaleta, bo dwa obrazy po 0,5 krycia daja trzeci obraz.
       Przy PISMIE daja kase: dwa zdania po 0,4 krycia stojace jedno na drugim
       sa oba nieczytelne. Dlatego wyjscie konczy sie dokladnie tam, gdzie
       zaczyna sie wejscie. Przez ulamek drogi pole jest puste i tak ma byc:
       to jest CIECIE, a nie przerwa w ladowaniu. */
    function windowAt(i, n, t, fade) {
      var a = i / n, b = (i + 1) / n, w = (b - a) * fade;
      if (t <= a) return i === 0 ? 1 : 0;
      if (t >= b) return i === n - 1 ? 1 : 0;
      if (i > 0 && t < a + w) return (t - a) / w;
      if (i < n - 1 && t > b - w) return (b - t) / w;
      return 1;
    }

    // Porownanie po ZAPAMIETANEJ wartosci, a nie po film.src: przegladarka
    // rozwija src do adresu bezwzglednego, wiec porownanie z atrybutem
    // data-* nigdy by sie nie zgodzilo i plik ladowalby sie w kolko.
    function zrodlo(src, poster) {
      if (!src || src === zalozone) return;
      zalozone = src;
      try {
        if (poster) film.poster = poster;
        film.src = src;
        film.load();
      } catch (err) { /* zostaje to, co bylo */ }
    }

    /* Glowica: przewiniecia sa koalescowane, ale z ZAWOREM CZASOWYM.
       Bez limitu jedno przewiniecie, ktore sie nie konczy (a sa renderery,
       w ktorych nie konczy sie nigdy), blokuje film na zawsze. */
    var seeking = false, seekAt = 0;
    film.addEventListener("seeked", function () { seeking = false; });
    function head(t) {
      var d = film.duration;
      if (!d || !isFinite(d)) return;
      if (seeking && Date.now() - seekAt < 400) return;
      seeking = true; seekAt = Date.now();
      var end = d - 0.05;
      try { film.currentTime = Math.min(end, Math.max(0, t * end)); }
      catch (err) { seeking = false; }
    }

    function update() {
      if (tryb !== "akt") return;
      var n = cues.length;
      var span = sec.offsetHeight - window.innerHeight;
      var t = span > 0
        ? Math.min(1, Math.max(0, -sec.getBoundingClientRect().top / span))
        : 0;
      for (var i = 0; i < n; i++) {
        cues[i].style.setProperty("--o", windowAt(i, n, t, 0.18).toFixed(3));
      }
      head(t);
      if (!moved && t > 0.01) { moved = true; sec.classList.add("is-moved"); }
    }

    window.addEventListener("scroll", update, { passive: true });
    // Przy zmianie rozmiaru NAJPIERW tryb, potem pozycja: update liczy sie
    // wzgledem aktu, wiec odwrotna kolejnosc wyliczalaby krycie podpisow
    // jeszcze dla poprzedniego trybu.
    window.addEventListener("resize", function () { apply(); update(); }, { passive: true });
    film.addEventListener("loadedmetadata", update);

    // Petla nie krezi sie poza kadrem: bateria telefonu. W akcie glowice
    // prowadzi przewijanie, wiec odtwarzanie jest tam wylaczone.
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (tryb === "akt" || reduceMotion) return;
          // play() zwraca obietnice, ktora odrzuca sie np. przy oszczedzaniu
          // energii. Nieobsluzona wysypuje konsole, a film i tak nie zagra.
          if (e.isIntersecting) { var pr = film.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else film.pause();
        });
      }, { threshold: 0.1 }).observe(film);
    }

    function apply() {
      var wide = mq.matches;
      var akt = wide && !reduceMotion && cues.length > 1;
      var chce = akt ? "akt" : (wide ? "film" : "petla");
      if (chce === tryb) return;
      tryb = chce;

      if (akt) {
        zrodlo(sec.dataset.filmScrub, sec.dataset.poster);
        try { film.removeAttribute("autoplay"); film.loop = false; film.pause(); }
        catch (err) { /* nic */ }
        sec.style.setProperty("--cues", cues.length);
        sec.classList.add("is-akt");
        update();
        return;
      }

      /* PONIZEJ 900 PX WCHODZI KWADRATOWA PETLA, a nie wyciety pionowo film.
         Klient poprosil o to wprost 18.09.2026 ("usun na mobile calkowicie
         film"), ale rachunek mowi to samo: w pionowym oknie bryla zajmowala
         jedna czwarta szerokosci pliku, wiec stolek byl na telefonie maly,
         a plik wazyl 608 KB. Petla z v1 jest kwadratowa, bryla ma w niej 66%
         szerokosci kadru, a plik wazy 188 KB. */
      zrodlo(wide ? sec.dataset.filmWide : sec.dataset.filmM,
             wide ? sec.dataset.poster : sec.dataset.posterM);

      sec.classList.remove("is-akt", "is-moved");
      moved = false;
      // Krycie ustawione przez akt MUSI ZNIKNAC. Poza aktem arkusz pokazuje
      // wszystkie hasla naraz, wiec zostawiony styl liniowy trzymalby czesc
      // z nich na zerze i po zwezeniu okna sekcja bylaby pusta.
      cues.forEach(function (c) { c.style.removeProperty("--o"); });

      if (reduceMotion) {
        // Petla bez dzwieku ma NIE startowac, gdy ktos poprosil system
        // o ograniczenie ruchu. Zostaje poster i kontrolki: material dalej
        // jest dostepny, tylko na zadanie.
        try {
          film.removeAttribute("autoplay");
          film.loop = false;
          film.controls = true;
          film.pause();
        } catch (err) { /* lepiej zostawic film grajacy niz wysypac reszte */ }
        return;
      }
      try {
        film.loop = true;
        var pr = film.play();
        if (pr && pr.catch) pr.catch(function () {});
      } catch (err) { /* nic */ }
    }

    /* DWA ZRODLA SYGNALU I TO JEST CELOWA NADMIAROWOSC.

       `change` z matchMedia jest scislejsze: odpala sie dokladnie raz, przy
       przekroczeniu progu. Ale nie wszedzie jest — starsze Safari zna tylko
       addListener, a w rendererze pod --virtual-time-budget zdarzenie nie
       dociera wcale (zmierzone sonda test-prog: ramka ma juz 1440 px
       i matchMedia zwraca true, a `change` nie pada). Dlatego tryb liczy
       takze zwykly `resize` wyzej.

       Wolanie apply() w kolko nic nie kosztuje, bo funkcja wychodzi od razu,
       gdy tryb sie nie zmienil, i to jest cala przyczyna, dla ktorej wolno
       tu miec dwa zrodla naraz zamiast wybierac jedno. */
    if (mq.addEventListener) mq.addEventListener("change", apply);
    else if (mq.addListener) mq.addListener(apply);
    apply();
  }

  /* ---------- rzad przewijany w kolko ----------
     Klient poprosil o poziomy scroll bez konca (18.09.2026), a po pierwszej
     wersji zglosil, ze rzad "zatrzymuje sie po 4 kafelku i trzeba wracac
     w druga strone". Tak wlasnie bylo i przyczyna jest fizyczna.

     CZEGO NIE WOLNO ROBIC: przestawiac scrollLeft W TRAKCIE przewijania.
     Poprzednia wersja trzymala trzy komplety i przeskakiwala o dlugosc
     kompletu, gdy tylko pozycja wyszla poza srodkowy. Przeskok wypadal wiec
     dokladnie w czasie rzutu palcem, a kazde przypisanie scrollLeft ZABIJA
     bezwladnosc: przegladarka traktuje je jak nowe przewijanie i kasuje
     rozped. Z zewnatrz wyglada to tak, ze rzad staje w miejscu.

     JAK TO DZIALA TERAZ: kompletow jest PIEC, start na trzecim, a pozycje
     wyrownuje sie dopiero WTEDY, GDY PRZEWIJANIE USTANIE. Rzut palcem ma
     do dyspozycji dwa komplety w kazda strone, czyli wielokrotnie wiecej,
     niz jeden rzut potrafi przejechac, wiec do sciany nie dojezdza nigdy.
     Wyrownanie po ciszy jest niewidoczne, bo w tym miejscu na ekranie stoi
     dokladnie ta sama tresc.

     Trzy warunki, bez ktorych to nie dziala:
     1. KOPIE SA UKRYTE PRZED CZYTNIKIEM (aria-hidden, tabindex -1). Bez tego
        ta sama opinia czytana piec razy jest bledem dostepnosci.
     2. BEZ PRZYCIAGANIA. scroll-snap w polaczeniu z podmiana scrollLeft
        odbija pozycje z powrotem i rzad szarpie.
     3. TYLKO ZE SKRYPTEM. Bez JS zostaje zwykly przewijany rzad, ktory jest
        poprawna trescia sam z siebie.                                      */
  function initLoop(rail, always) {
    if (!rail || rail.dataset.loopOn === "1") return null;
    if (reduceMotion) return null;
    if (!always && !window.matchMedia("(max-width: 899px)").matches) return null;

    var kids = Array.prototype.slice.call(rail.children);
    var n = kids.length;
    if (n < 2) return null;
    rail.dataset.loopOn = "1";

    function copy(node) {
      var c = node.cloneNode(true);
      c.setAttribute("aria-hidden", "true");
      c.setAttribute("data-clone", "true");
      Array.prototype.forEach.call(c.querySelectorAll("a,button,input,select,textarea"),
        function (el) { el.tabIndex = -1; });
      return c;
    }
    // Dwa komplety z przodu i dwa z tylu. Pierwsza wersja miala po jednym
    // i to byl za maly zapas na jeden rzut palcem.
    var reps = 2, i, j;
    for (i = 0; i < reps; i++) kids.forEach(function (k) { rail.appendChild(copy(k)); });
    for (i = 0; i < reps; i++) {
      for (j = n - 1; j >= 0; j--) rail.insertBefore(copy(kids[j]), rail.firstChild);
    }

    function setW() {
      // Dlugosc JEDNEGO kompletu liczona z POZYCJI, a nie z sumy szerokosci:
      // sumowanie gubi odstepy siatki, a te skladaja sie na kilkadziesiat px.
      var all = rail.children;
      return all[n].offsetLeft - all[0].offsetLeft;
    }

    var w = 0, lock = false, home = reps;   // komplet, na ktorym stoimy
    function center() {
      w = setW();
      if (w <= 0) return;
      lock = true; rail.scrollLeft = w * home; lock = false;
    }
    // Wyrownanie liczy sie MODULEM, a nie jednym skokiem: po bardzo dlugim
    // rzucie pozycja bywa dwa komplety od srodka i jeden skok by nie starczyl.
    function settle() {
      if (lock || w <= 0) return;
      var k = Math.round((rail.scrollLeft - w * home) / w);
      if (k === 0) return;
      lock = true; rail.scrollLeft -= k * w; lock = false;
    }

    var idle = 0;
    rail.addEventListener("scroll", function () {
      if (lock || w <= 0) return;
      // Zawor bezpieczenstwa: gdyby ktos dojechal pod sama sciane, wyrownujemy
      // od razu, bo tam przewijanie i tak juz stanelo.
      var max = rail.scrollWidth - rail.clientWidth;
      if (rail.scrollLeft < w * 0.35 || rail.scrollLeft > max - w * 0.35) { settle(); return; }
      clearTimeout(idle);
      idle = setTimeout(settle, 140);
    }, { passive: true });
    // scrollend jest dokladniejsze od licznika czasu tam, gdzie istnieje.
    if ("onscrollend" in window) {
      rail.addEventListener("scrollend", function () { clearTimeout(idle); settle(); });
    }

    window.addEventListener("resize", center, { passive: true });
    // Po zaladowaniu zdjec szerokosci sie zmieniaja, wiec punkt startowy
    // trzeba wyliczyc jeszcze raz.
    window.addEventListener("load", center);
    center();

    return {
      count: n,
      // Pozycja liczona w KOMPLECIE, zeby znacznik pod paskiem pokazywal
      // jedna z trzech opinii, a nie jedna z pietnastu kopii.
      index: function () {
        var step = rail.clientWidth || 1;
        return ((Math.round(rail.scrollLeft / step) % n) + n) % n;
      },
      step: function (dir) {
        var step = rail.clientWidth || 1;
        try {
          rail.scrollBy({ left: dir * step, behavior: reduceMotion ? "auto" : "smooth" });
        } catch (err) { rail.scrollLeft += dir * step; }
      }
    };
  }

  /* ---------- hero: sekwencja klatek tam i z powrotem ---------- */
  function initStage(elm) {
    // Wylaczony ruch: nie dogrywamy 275 KB, ktorych i tak nikt nie zobaczy.
    if (reduceMotion) return;

    var frames = Array.prototype.slice.call(elm.querySelectorAll("img"));
    var rest = (elm.dataset.frames || "").split(",").filter(Boolean);

    function animate() {
      if (frames.length < 2) return;

      var step = parseInt(elm.dataset.interval, 10) || 135;
      var i = 0, dir = 1, last = 0, raf = null;

      function tick(t) {
        if (t - last > step) {
          frames[i].classList.remove("is-on");
          i += dir;
          if (i >= frames.length - 1) { i = frames.length - 1; dir = -1; }
          else if (i <= 0) { i = 0; dir = 1; }
          frames[i].classList.add("is-on");
          last = t;
        }
        raf = requestAnimationFrame(tick);
      }

      // Poza ekranem petla nie tylko nie zmienia klatek, w ogole nie chodzi.
      function run(on) {
        if (on && raf === null) raf = requestAnimationFrame(tick);
        else if (!on && raf !== null) { cancelAnimationFrame(raf); raf = null; }
      }

      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          run(entries[0].isIntersecting);
        }, { threshold: 0.1 }).observe(elm);
      } else {
        run(true);
      }
    }

    if (!rest.length) { animate(); return; }

    /* Klatki 2 do 8 pobieramy dopiero po load, zeby nie konkurowaly o pasmo
       z pierwsza klatka, ktora jest elementem LCP. */
    function preload() {
      var extra = rest.map(function (src) {
        var img = new Image(1400, 1400);
        img.alt = "";
        img.decoding = "async";
        img.setAttribute("aria-hidden", "true");
        img.src = src;
        return img;
      });

      var pending = extra.length;
      function done() {
        if (--pending > 0) return;
        extra.forEach(function (img) { elm.appendChild(img); frames.push(img); });
        animate();
      }

      extra.forEach(function (img) {
        if (img.complete) done();
        else { img.onload = done; img.onerror = done; }
      });
    }

    if (document.readyState === "complete") preload();
    else window.addEventListener("load", preload);
  }

  /* ---------- koszyk: jedno wejscie dla calego motywu ----------
     Kazde dodanie idzie tedy, zeby licznik, szuflada i pasek zakupowy
     zawsze mowily to samo. */
  var Cart = {
    add: function (id, qty) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: Number(id), quantity: Number(qty) || 1 })
      }).then(function (r) {
        return r.json().then(function (b) {
          if (!r.ok) throw new Error(b.description || b.message || "");
          return b;
        });
      });
    },
    change: function (key, qty) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: Number(qty) })
      }).then(function (r) { return r.json(); });
    },
    get: function () {
      return fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); });
    }
  };

  /* ---------- szuflada koszyka ----------
     Otwiera sie po dodaniu do koszyka i po klinieciu licznika w naglowku.
     Gdy jej nie ma w DOM albo cokolwiek pojdzie nie tak, wszystkie sciezki
     prowadza do zwyklej strony /cart. Zakupu nie wolno uzaleznic od panelu. */
  var Drawer = (function () {
    var root, panel, list, foot, closeBtn, opener = null, ready = false;

    function money2(c) { return money(c, root.dataset.currency); }

    function line(item) {
      var row = el("div", "dl");

      var fig = el("div", "dl__img");
      if (item.image) {
        var img = new Image();
        img.src = sized(item.image, 180);
        img.alt = "";
        img.loading = "lazy";
        fig.appendChild(img);
      }
      row.appendChild(fig);

      var col = el("div");
      var t = el("div", "dl__t");
      t.appendChild(el("b", null, item.product_title || item.title));
      t.appendChild(el("span", "dl__price", money2(item.final_line_price)));
      col.appendChild(t);
      if (item.variant_title) col.appendChild(el("span", "dl__var", item.variant_title));

      var bot = el("div", "dl__bot");
      var qty = el("div", "qty");
      var minus = el("button", null, "−");
      var input = el("input");
      var plus = el("button", null, "+");
      minus.type = plus.type = "button";
      minus.setAttribute("aria-label", root.dataset.tLess || "");
      plus.setAttribute("aria-label", root.dataset.tMore || "");
      input.type = "number";
      input.min = "0";
      input.value = item.quantity;
      input.setAttribute("aria-label", root.dataset.tQty || "");
      qty.appendChild(minus); qty.appendChild(input); qty.appendChild(plus);

      minus.addEventListener("click", function () { set(item.key, item.quantity - 1); });
      plus.addEventListener("click", function () { set(item.key, item.quantity + 1); });
      input.addEventListener("change", function () { set(item.key, parseInt(input.value, 10) || 0); });

      var rm = el("button", "dl__rm", root.dataset.tRemove || "");
      rm.type = "button";
      rm.addEventListener("click", function () { set(item.key, 0); });

      bot.appendChild(qty);
      bot.appendChild(rm);
      col.appendChild(bot);
      row.appendChild(col);
      return row;
    }

    function set(key, qty) {
      root.classList.add("is-busy");
      Cart.change(key, Math.max(0, qty))
        .then(render)
        .catch(function () { window.location.href = "/cart"; })
        .finally(function () { root.classList.remove("is-busy"); });
    }

    function render(cart) {
      paintCount(cart.item_count);
      var n = root.querySelector("[data-drawer-n]");
      if (n) n.textContent = cart.item_count;

      list.textContent = "";
      if (!cart.item_count) {
        var empty = el("div", "drawer__empty");
        empty.appendChild(el("p", null, root.dataset.tEmpty || ""));
        list.appendChild(empty);
        foot.hidden = true;
        return;
      }
      foot.hidden = false;
      cart.items.forEach(function (item) { list.appendChild(line(item)); });

      var total = root.querySelector("[data-drawer-total]");
      if (total) total.textContent = money2(cart.total_price);
    }

    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll(
        'a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'
      )).filter(function (n) { return n.offsetParent !== null; });
    }

    function onKey(e) {
      if (e.key === "Escape") { close(); return; }
      if (e.key !== "Tab") return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      if (!ready) { window.location.href = "/cart"; return; }
      opener = document.activeElement;
      root.classList.add("is-open");
      root.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("is-locked");
      document.addEventListener("keydown", onKey);
      if (closeBtn) closeBtn.focus();
      refresh();
    }

    function close() {
      if (!ready) return;
      root.classList.remove("is-open");
      root.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("is-locked");
      document.removeEventListener("keydown", onKey);
      if (opener && opener.focus) opener.focus();
      opener = null;
    }

    function refresh() {
      if (!ready) return Promise.resolve();
      return Cart.get().then(render).catch(function () {});
    }

    function mount() {
      root = document.querySelector("[data-drawer]");
      if (!root) return;
      panel = root.querySelector("[data-drawer-panel]");
      list = root.querySelector("[data-drawer-list]");
      foot = root.querySelector("[data-drawer-foot]");
      closeBtn = root.querySelector("[data-drawer-close]");
      if (!panel || !list || !foot) return;
      ready = true;

      root.querySelectorAll("[data-drawer-close]").forEach(function (b) {
        b.addEventListener("click", close);
      });

      // Licznik w naglowku otwiera szuflade, ale zostaje linkiem do /cart:
      // srodkowy przycisk myszy i "otworz w nowej karcie" maja dzialac.
      document.querySelectorAll("[data-drawer-open]").forEach(function (a) {
        a.addEventListener("click", function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
          e.preventDefault();
          open();
        });
      });
    }

    return { mount: mount, open: open, close: close, refresh: refresh,
             isReady: function () { return ready; } };
  })();

  /* ---------- galeria produktu ---------- */
  function initGallery(root) {
    var gal = root.querySelector("[data-gal]");
    if (!gal) return null;

    var main = gal.querySelector("[data-gal-main]");
    var thumbs = gal.querySelector("[data-gal-thumbs]");
    var counter = gal.querySelector("[data-gal-count]");
    var prev = gal.querySelector('[data-gal-step="-1"]');
    var next = gal.querySelector('[data-gal-step="1"]');
    if (!main) return null;

    // Miniatury dziela sie na grupy wariantow (data-group). Widoczne sa tylko
    // te z grupy wybranego koloru plus wspolne (pusta grupa), wiec licznik
    // i strzalki musza chodzic po WIDOCZNYCH, nie po wszystkich.
    var allSlides = thumbs ? Array.prototype.slice.call(thumbs.children) : [];
    var slides = allSlides.filter(function (b) { return !b.hidden; });
    var i = Math.max(0, slides.findIndex(function (b) {
      return b.getAttribute("aria-current") === "true";
    }));

    function paint() {
      /* Licznik sklada sie z DWOCH czesci, nie z jednego napisu: numer
         biezacego kadru jest atramentowy, reszta przymglona. Jeden ciag
         "3 / 8" w jednym kolorze czyta sie jak etykieta formularza; rozbity
         mowi, ktora liczba jest odpowiedzia na pytanie „gdzie jestem". */
      if (counter) {
        counter.textContent = "";
        counter.appendChild(el("b", null, String(i + 1)));
        counter.appendChild(document.createTextNode(" / " + slides.length));
      }
      if (prev) prev.disabled = false;
      if (next) next.disabled = false;
      slides.forEach(function (b, k) { b.setAttribute("aria-current", String(k === i)); });
      // Miniatura poza polem widzenia sama wjezdza w kadr paska.
      if (slides[i] && thumbs && thumbs.scrollWidth > thumbs.clientWidth) {
        var b = slides[i];
        var left = b.offsetLeft - (thumbs.clientWidth - b.offsetWidth) / 2;
        thumbs.scrollTo({ left: left, behavior: reduceMotion ? "auto" : "smooth" });
      }
    }

    // Podmiana zrodla przez przezroczystosc: twarde przeskoki miedzy
    // zdjeciami o roznym kadrze wygladaly jak przeladowanie strony.
    function show(k, src, alt) {
      if (slides.length) i = (k + slides.length) % slides.length;
      var url = src || (slides[i] && slides[i].dataset.src);
      if (!url) return;
      if (reduceMotion) {
        main.src = url;
      } else {
        gal.classList.add("is-swap");
        var pre = new Image();
        pre.onload = pre.onerror = function () {
          main.src = url;
          requestAnimationFrame(function () { gal.classList.remove("is-swap"); });
        };
        pre.src = url;
      }
      main.removeAttribute("srcset");
      if (alt != null) main.alt = alt;
      paint();
    }

    if (prev) prev.addEventListener("click", function () { show(i - 1); });
    if (next) next.addEventListener("click", function () { show(i + 1); });

    if (thumbs) {
      thumbs.addEventListener("click", function (e) {
        var b = e.target.closest("button");
        if (!b) return;
        show(slides.indexOf(b));
      });
    }

    // Strzalki klawiatury dzialaja, gdy galeria ma ognisko, a nie globalnie:
    // inaczej odbieralyby nawigacje reszcie strony.
    gal.setAttribute("tabindex", "-1");
    gal.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { e.preventDefault(); show(i - 1); }
      else if (e.key === "ArrowRight") { e.preventDefault(); show(i + 1); }
    });

    // Przesuniecie palcem. Prog 40 px i przewaga poziomu nad pionem,
    // zeby zwykle przewijanie strony nie przerzucalo zdjec.
    var x0 = null, y0 = null;
    gal.addEventListener("touchstart", function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    gal.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) show(i + (dx < 0 ? 1 : -1));
      x0 = y0 = null;
    }, { passive: true });

    paint();

    // Zmiana wariantu wchodzi ta sama droga co klikniecie w miniature.
    return {
      /* Przelaczenie koloru przebudowuje zestaw miniatur: zostaja wspolne
         (pusta grupa) i te z grupy wybranego wariantu. Dopiero potem
         pokazujemy zdjecie wariantu, zeby indeks liczyl sie juz na nowej
         liscie — inaczej licznik pokazywalby "3 / 11" przy trzech kadrach. */
      setVariant: function (id, src, alt) {
        if (allSlides.length) {
          allSlides.forEach(function (b) {
            var g = b.dataset.group || "";
            b.hidden = !(g === "" || g === String(id));
          });
          slides = allSlides.filter(function (b) { return !b.hidden; });
          if (!slides.length) slides = allSlides.slice();
          i = 0;
        }
        this.toVariantImage(src, alt);
      },
      toVariantImage: function (src, alt) {
        var k = slides.findIndex(function (b) {
          return (b.dataset.src || "").split("?")[0] === (src || "").split("?")[0];
        });
        if (k > -1) show(k, null, alt);
        else if (src) show(i, sized(src, 1200), alt);
        else show(i);
      }
    };
  }

  /* ---------- produkt: warianty, ilosc, koszyk ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector("[data-variants]");
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var currency = root.dataset.currency;
    // Jedno zrodlo prawdy dla tekstow: locale przez Liquid, nie literaly tutaj.
    var T = {
      add:   root.dataset.tAdd   || "",
      added: root.dataset.tAdded || "",
      sold:  root.dataset.tSold  || "",
      stock: root.dataset.tStock || "",
      error: root.dataset.tError || ""
    };
    var gallery = initGallery(root);
    var priceEl = root.querySelector("[data-price]");
    var compare = root.querySelector("[data-compare]");
    var stock   = root.querySelector("[data-stock]");
    var idInput = root.querySelector("[data-variant-id]");
    var addBtn  = root.querySelector("[data-add]");
    var form    = root.querySelector("[data-add-form]");
    var groups  = Array.prototype.slice.call(root.querySelectorAll("[data-opt]"));

    function selected() {
      return groups.map(function (g) {
        var on = g.querySelector('[aria-pressed="true"]');
        return on ? on.dataset.value : null;
      });
    }

    function findVariant(values) {
      return variants.filter(function (v) {
        return values.every(function (val, i) { return v.options[i] === val; });
      })[0];
    }

    function apply(v) {
      if (!v) return;

      idInput.value = v.id;
      priceEl.textContent = money(v.price, currency);

      if (compare) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compare.textContent = money(v.compare_at_price, currency);
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }

      // Wariant bez stanu magazynowego nie moze zostac kupiony (brief pkt 31).
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? T.add : T.sold;
      if (stock) {
        stock.dataset.available = String(v.available);
        stock.textContent = v.available ? stock.dataset.inStock || T.stock : T.sold;
      }

      // Zmiana wariantu przebudowuje CALA galerie, nie tylko glowny kadr
      // (brief pkt 12 + prosba klienta: "jak klikasz bialy, to zdjecia
      // powyzej sa wersji bialej").
      if (gallery) {
        gallery.setVariant(v.id,
          v.featured_image ? v.featured_image.src : null,
          v.featured_image ? v.featured_image.alt : null);
      }

      // Pasek zakupowy ma pokazywac to, co jest wybrane. Nazwe wariantu
      // podmieniamy tylko wtedy, gdy produkt naprawde ma warianty: przy
      // jednym wariancie Shopify nazywa go "Default Title".
      document.querySelectorAll("[data-buy-price]").forEach(function (n) {
        n.textContent = money(v.price, currency);
      });
      // Pasek ma znac wybrany wariant takze na sciezce bez JavaScriptu
      // (ukryte pole) i blokowac zakup wyprzedanego koloru.
      document.querySelectorAll("[data-buy-variant-id]").forEach(function (n) {
        n.value = v.id;
      });
      document.querySelectorAll("[data-buy-form]").forEach(function (f) {
        f.dataset.sold = String(!v.available);
        var b = f.querySelector("[data-buy-add]");
        if (b) b.disabled = !v.available;
      });
      // Pasek pokazuje napis z probek, a nie v.title: tytul wariantu przychodzi
      // z panelu Shopify i to jego wlasnie podmienia nazwa-wariantu.
      if (groups.length) {
        var shown = groups.map(function (g) {
          var on = g.querySelector('[aria-pressed="true"]');
          return on ? (on.dataset.label || on.dataset.value) : "";
        }).filter(Boolean).join(" / ");
        document.querySelectorAll("[data-buy-variant]").forEach(function (n) {
          n.textContent = shown || v.title || "";
        });
      }

      // Adres z wariantem, zeby dalo sie wyslac link do konkretnego koloru.
      if (window.history.replaceState && root.dataset.url) {
        window.history.replaceState({}, "", root.dataset.url + "?variant=" + v.id);
      }
    }

    if (stock) stock.dataset.inStock = stock.textContent.trim();

    groups.forEach(function (g) {
      g.addEventListener("click", function (e) {
        var btn = e.target.closest(".sw");
        if (!btn) return;
        Array.prototype.forEach.call(g.children, function (c) {
          c.setAttribute("aria-pressed", String(c === btn));
        });
        // data-label niesie napis DLA CZLOWIEKA, data-value klucz wariantu.
        // Patrz snippets/nazwa-wariantu.liquid: wartosc opcji w panelu brzmi
        // inaczej niz to, co ma stac na stronie.
        var label = root.querySelector('[data-opt-label="' + g.dataset.opt + '"]');
        if (label) label.textContent = btn.dataset.label || btn.dataset.value;
        apply(findVariant(selected()));
      });
    });

    var qtyInput = root.querySelector("[data-qty-input]");
    root.addEventListener("click", function (e) {
      var b = e.target.closest("[data-qty]");
      if (!b || !qtyInput) return;
      var n = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, Math.min(99, n + parseInt(b.dataset.qty, 10)));
    });

    /* Dodanie do koszyka bez przeladowania strony, zakonczone otwarciem
       szuflady. Gdy szuflady nie ma, przycisk wraca do napisu i klient
       widzi zmieniony licznik w naglowku, wiec nic nie ginie po cichu. */
    if (form) {
      form.addEventListener("submit", function (e) {
        // Bez fetch zostawiamy zwykly POST formularza: przegladarka
        // przeladuje strone koszyka i zakup dojdzie do skutku.
        if (!window.fetch) return;
        e.preventDefault();
        var label = addBtn.textContent;
        addBtn.disabled = true;

        Cart.add(idInput.value, qtyInput ? qtyInput.value : 1)
          .then(function () {
            addBtn.textContent = T.added;
            if (Drawer.isReady()) Drawer.open();
            else return Cart.get().then(function (c) { paintCount(c.item_count); });
          })
          .catch(function (err) { addBtn.textContent = err.message || T.error; })
          .finally(function () {
            setTimeout(function () {
              addBtn.textContent = label;
              addBtn.disabled = false;
            }, 1600);
          });
      });
    }
  }

  /* ---------- opinie: poziomy pasek wypowiedzi ----------
     Pasek jest NATYWNYM przewijaniem i dziala bez tego modulu: palec
     i gladzik przesuwaja go same. Modul doklada wylacznie strzalki
     i znacznik pozycji, czyli rzeczy, ktorych mysz bez kola poziomego
     nie ma jak obsluzyc.

     Pozycja liczy sie z scrollLeft, a nie z wlasnego licznika: uzytkownik
     moze przesunac pasek palcem miedzy klinieciami i licznik rozjechalby
     sie z tym, co widac. Jedno zrodlo prawdy jest w przegladarce.        */
  /* ---------- opinie ----------
     Pasek przewija sie BEZ KONCA takze na biurku, a nie tylko w dloni, i to
     jest wprost prosba klienta (18.09.2026). Tu jest to uzasadnione inaczej
     niz przy rzedzie makr: opinii sa trzy i po dojechaniu do ostatniej stara
     wersja gasila strzalke „dalej", czyli sekcja konczyla sie slepym zaulkiem
     w miejscu, w ktorym ma przekonywac.

     Kadrow juz tu nie ma. Klient kazal je zdjac i wyeksponowac same
     wypowiedzi, wiec zniknal tez caly kod przelaczajacy zdjecia.           */
  function initRev(sec) {
    var rail = sec.querySelector("[data-rev-rail]");
    var bar = sec.querySelector("[data-rev-bar]");
    if (!rail || !bar) return;

    var items = Array.prototype.slice.call(rail.children);
    if (items.length < 2) return;

    // true, bo pasek opinii zapetla sie na KAZDEJ szerokosci.
    var loop = initLoop(rail, true);
    var n = loop ? loop.count : items.length;

    var dots = bar.querySelector("[data-rev-dots]");
    var steps = Array.prototype.slice.call(bar.querySelectorAll("[data-rev-step]"));

    if (dots) {
      for (var i = 0; i < n; i++) dots.appendChild(document.createElement("i"));
    }

    function index() {
      if (loop) return loop.index();
      var w = rail.clientWidth || 1;
      return Math.max(0, Math.min(n - 1, Math.round(rail.scrollLeft / w)));
    }

    function paint() {
      var i = index();
      if (dots) {
        Array.prototype.forEach.call(dots.children, function (d, k) {
          d.classList.toggle("is-on", k === i);
        });
      }
      // ZADNA STRZALKA NIE JEST WYGASZONA: pasek nie ma konca, wiec nie ma
      // kierunku, w ktorym nie da sie juz pojsc.
    }

    steps.forEach(function (b) {
      b.addEventListener("click", function () {
        var dir = parseInt(b.dataset.revStep, 10);
        if (loop) { loop.step(dir); return; }
        var to = Math.max(0, Math.min(n - 1, index() + dir));
        try {
          rail.scrollTo({ left: to * rail.clientWidth,
                          behavior: reduceMotion ? "auto" : "smooth" });
        } catch (err) { rail.scrollLeft = to * rail.clientWidth; }
      });
    });

    rail.addEventListener("scroll", paint, { passive: true });
    window.addEventListener("resize", paint, { passive: true });
    paint();
  }

  /* ---------- pasek zakupowy przy dolnej krawedzi ---------- */
  function initBar(bar) {
    /* Punktem odniesienia sa WSZYSTKIE prawdziwe przyciski zakupu, nie
       jeden formularz w sekcji produktu. Zasada zostaje ta sama co zawsze:
       pasek milczy, dopoki widac prawdziwy przycisk "Dodaj do koszyka",
       i wchodzi, kiedy zniknie z ekranu.

       Rozszerzenie wymusil nowy hero: przycisk jest tam PRZYPIETY przez trzy
       ekrany przewijania, a stara regula (pokaz po 0,85 ekranu) zapalala
       pasek juz w drugim, czyli dokladnie wtedy, gdy ten sam przycisk stal
       pod palcem. Dwa identyczne przyciski naraz to nie jest druga szansa
       na zakup, tylko halas.

       Formularz samego paska jest wykluczony: pasek nie moze uznac wlasnego
       przycisku za powod, zeby sie schowac.                                */
    var forms = Array.prototype.slice.call(
      document.querySelectorAll("[data-add-form], [data-buy-form]")
    ).filter(function (form) { return !bar.contains(form); });
    if (!forms.length) return;

    function update() {
      var h = window.innerHeight;
      var anyInView = false;
      // Czy pierwszy przycisk na stronie wyjechal juz nad gorna krawedz.
      var passedFirst = false;

      for (var i = 0; i < forms.length; i++) {
        var r = forms[i].getBoundingClientRect();
        if (r.bottom > 56 && r.top < h - 40) anyInView = true;
        if (i === 0 && r.bottom <= 56) passedFirst = true;
      }

      /* Na karcie produktu formularz stoi PONIZEJ pierwszego ekranu, wiec
         sam warunek "minelismy pierwszy przycisk" nie zapali paska nigdy,
         dopoki ktos nie przewinie za formularz. Drugi warunek zapala go po
         jednym ekranie przewijania. Heroa to nie dotyczy, bo tam przycisk
         jest przypiety i `anyInView` i tak trzyma pasek wylaczony. */
      var past = window.scrollY > h * 0.85;

      /* Granica od dolu to WIERSZ REJESTROWY stopki, nie jej gorna krawedz.
         Poprzednia regula ("chowaj, gdy widac stopke") na karcie produktu
         zabierala pasek dokladnie w chwili, w ktorej mial sie pojawic:
         okno miedzy koncem formularza a poczatkiem stopki bylo ujemne.
         Teraz pasek ustepuje tylko temu, co naprawde musi byc widoczne
         w calosci: NIP, REGON, KRS i prawa autorskie. */
      var guard = document.querySelector(".foot__bar") || document.querySelector(".foot");
      var atFooter = guard &&
        guard.getBoundingClientRect().top < h - bar.offsetHeight - 8;

      bar.classList.toggle("is-on", (passedFirst || past) && !anyInView && !atFooter);
    }

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    update();
  }

  /* ---------- drugi przycisk zakupu ----------
     Na stronie sa TRZY miejsca, z ktorych da sie kupic: formularz w sekcji
     produktu, lepki pasek przy dolnej krawedzi i domykajace CTA na koncu
     strony. Pierwszy jest zrodlem prawdy, dwa pozostale sa jego echem
     i dlatego dziela ten sam kod oraz te same atrybuty data-buy-*.

     Wczesniej ta obsluga siedziala w srodku initBar i dotyczyla wylacznie
     paska. Domykajace CTA bylo wtedy kotwica do sekcji produktu: klikniete
     na samym dole strony PRZEWIJALO o dziesiec ekranow w gore, zamiast
     dodac do koszyka. Klient zglosil to jako pierwsza rzecz do poprawy.

     Dwie zasady zostaja z paska, bo obie kosztowaly juz jedno zgloszenie:
     1. To FORMULARZ, nie kotwica. Dopoki theme.js (defer) nie wstanie, zwykly
        POST na routes.cart_add_url naprawde dodaje produkt; kotwica tylko
        przewijala.
     2. O wariancie decyduje sekcja produktu, a wlasne ukryte pole jest
        zapasem na sciezke bez JavaScriptu. Bez id nie zgadujemy: puszczamy
        formularz normalnie, zeby Shopify odrzucil albo dodal po swojemu.
        Cicha porazka bylaby gorsza od przeladowania strony.                */
  function bindQuickAdd(form) {
    if (!form || !window.fetch) return;

    var btn = form.querySelector("[data-buy-add]");
    var busy = false;

    form.addEventListener("submit", function (e) {
      var src = document.querySelector("[data-product] [data-variant-id]");
      var own = form.querySelector("[data-buy-variant-id]");
      var id = (src && src.value) || (own && own.value);
      if (!id) return;

      e.preventDefault();
      if (busy) return;
      busy = true;
      if (btn) btn.disabled = true;

      Cart.add(id, 1)
        .then(function () {
          if (Drawer.isReady()) Drawer.open();
          else return Cart.get().then(function (c) { paintCount(c.item_count); });
        })
        .catch(function () { window.location.href = "/cart"; })
        .finally(function () {
          setTimeout(function () {
            busy = false;
            // Przycisk wraca do stanu, ktory wynika z dostepnosci wariantu,
            // a nie bezwarunkowo: wyprzedany kolor ma zostac zablokowany.
            if (btn) btn.disabled = form.dataset.sold === "true";
          }, 900);
        });
    });
  }

  /* ---------- koszyk: ilosc i kod rabatowy ---------- */
  function initCart() {
    document.querySelectorAll("[data-line-qty]").forEach(function (b) {
      b.addEventListener("click", function () {
        var input = document.querySelector('[data-line-input="' + b.dataset.line + '"]');
        if (!input) return;
        var n = parseInt(input.value, 10) || 0;
        input.value = Math.max(0, n + parseInt(b.dataset.lineQty, 10));
        input.form.submit();
      });
    });

    var df = document.querySelector("[data-discount-form]");
    if (!df) return;

    df.addEventListener("submit", function (e) {
      e.preventDefault();
      var code = df.querySelector('[name="code"]').value.trim();
      if (!code) return;
      // Adres /discount/KOD zapisuje rabat w sesji i wraca do koszyka,
      // kod naliczy sie od razu, bez czekania na checkout. Kod wraca
      // w adresie, zeby po powrocie dalo sie sprawdzic, czy zostal przyjety.
      window.location.href =
        "/discount/" + encodeURIComponent(code) +
        "?redirect=" + encodeURIComponent("/cart?code=" + code);
    });

    /* Shopify przy blednym kodzie po prostu wraca na koszyk i milczy.
       Porownujemy kod z adresu z tym, co faktycznie zostalo naliczone. */
    var asked = new URLSearchParams(window.location.search).get("code");
    if (!asked) return;

    var applied = (df.dataset.applied || "").toLowerCase();
    if (applied.indexOf(asked.toLowerCase() + "|") > -1) return;

    var msg = document.createElement("p");
    msg.className = "cart__err";
    msg.setAttribute("role", "status");
    msg.textContent = df.dataset.tBad || "";
    df.appendChild(msg);
    var field = df.querySelector('[name="code"]');
    if (field) { field.value = asked; field.setAttribute("aria-invalid", "true"); }
  }

  /* ---------- odslony przy scrollu ----------
     Strona ma sprawiac wrazenie skladanej, a nie animowanej: 14 px w gore
     i 0,7 s, z drobnym opoznieniem miedzy sasiadami. Kadr hero jest celowo
     pominiety, to element LCP i nie wolno opozniac jego malowania. */
  /* HERO NIE JEST NA TEJ LISCIE i nie moze na nia wrocic.
     Naglowek, lead i CTA hero widac w pierwszej klatce, wiec nie ma czego
     odslaniac, a kazda milisekunda, w ktorej sa ukryte, to pusta strona.
     Wczesniej tu byly i przy niedostarczonym zdarzeniu obserwatora klient
     dostawal piaskowy prostokat bez ani jednego slowa. */
  var RISE = [
    ".mark",
    "section h2", ".lead",
    ".cmp", ".prob__one", ".prob__say h2",
    ".card", ".kit__lead", ".tl__i", ".kit__item", ".kit__note",
    ".how__foot > *", ".scale", ".specs div", ".spec__pics figure",
    ".faq__head", ".faq__list details",
    ".prod__grid > *", ".final__in > *",
    ".how__stage"
  ].join(",");

  function initRise() {
    if (reduceMotion || !("IntersectionObserver" in window)) return;

    var io;
    try {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          reveal(e.target);
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.01 });
    } catch (err) {
      return; // obserwator nie wstal, nic nie chowamy
    }

    var nodes;
    try {
      nodes = Array.prototype.slice.call(document.querySelectorAll(RISE));
    } catch (err) {
      return; // niewspierany selektor, jak wyzej
    }

    /* SIATKA BEZPIECZENSTWA. Odslona jest OZDOBA i nie wolno jej decydowac
       o tym, czy tekst istnieje.

       Zdarzylo sie naprawde: obserwator nie dostarczyl ani jednego wpisu
       i strona stala z niewidocznymi naglowkami. Element chowamy dopiero
       w chwili obserwowania, wiec awaria samego obserwatora byla pokryta,
       ale MILCZENIE obserwatora, ktory wstal poprawnie, juz nie.

       Trzy zabezpieczenia, kazde tanie:
       1. przeglad tuz po starcie: co jest w kadrze, to pokazujemy od razu,
          bez czekania na wpis (i tak nie ma czego animowac, skoro widac),
       2. powtorka po load i po 1,5 s, gdy uklad sie przesunal po dogranych
          zdjeciach,
       3. twardy limit 4 s: potem widac WSZYSTKO, animowane czy nie.

       Czwarte i najwazniejsze: PRZEGLAD PRZY PRZEWIJANIU. Trzy pierwsze
       zabezpieczenia dzialaja tylko na starcie, wiec przy milczacym
       obserwatorze wystarczylo przewinac strone, zeby znowu trafic na
       niewidoczny tekst. Teraz odslony dzialaja poprawnie nawet wtedy, gdy
       IntersectionObserver nie dostarczy ANI JEDNEGO wpisu: nasluch schodzi
       sam, gdy nie ma juz czego odslaniac, wiec nie kosztuje nic po fakcie. */
    var left = [], lastSweep = 0, trail = null;

    function reveal(elm) {
      if (elm.classList.contains("is-in")) return;
      elm.classList.add("is-in");
      if (io) { try { io.unobserve(elm); } catch (err) {} }
    }
    function sweep() {
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      var rest = [];
      for (var i = 0; i < left.length; i++) {
        var elm = left[i];
        if (elm.classList.contains("is-in")) continue;
        var r = elm.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) reveal(elm);
        else rest.push(elm);
      }
      left = rest;
      // Gdy nie zostalo nic do odslonienia, przestajemy sluchac przewijania.
      if (!left.length) window.removeEventListener("scroll", onScroll);
    }
    /* Przeglad DUSZONY ZEGAREM, nie requestAnimationFrame.
       rAF wygladal tu na naturalny wybor, ale wiaze przeglad z klatka
       kompozytora, a ta nie zawsze istnieje: w headless Chrome pod
       --virtual-time-budget nie ma jej wcale i przeglad nie ruszal ani razu.
       To znaczy, ze w kazdym innym miejscu, gdzie klatki sa wstrzymane
       (zakladka w tle, oszczedzanie energii), siatka bezpieczenstwa tez by
       nie dzialala. Zegar nie ma tego warunku.

       Ogon jest potrzebny, bo duszenie gubi ostatnie zdarzenie, a to wlasnie
       ono wypada w miejscu, w ktorym uzytkownik sie zatrzymal. */
    function onScroll() {
      var now = Date.now();
      if (now - lastSweep >= 100) { lastSweep = now; sweep(); }
      if (trail) clearTimeout(trail);
      trail = setTimeout(function () { lastSweep = Date.now(); sweep(); }, 130);
    }
    function revealAll() {
      left.forEach(reveal);
      left = [];
      window.removeEventListener("scroll", onScroll);
    }

    var seen = {}, n = 0;
    nodes.forEach(function (elm) {
      if (elm.classList.contains("stage")) return; // kadr hero to LCP
      try {
        var key = elm.parentNode.__riseKey || (elm.parentNode.__riseKey = "g" + (n++));
        var i = seen[key] || 0;
        seen[key] = i + 1;
        elm.style.setProperty("--d", Math.min(i, 5) * 95 + "ms");
        elm.setAttribute("data-rise", "");
        left.push(elm);
        io.observe(elm);
      } catch (err) {
        elm.removeAttribute("data-rise");
      }
    });

    sweep();                                   // 1. to, co juz widac
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    if (document.readyState === "complete") setTimeout(sweep, 60);
    else window.addEventListener("load", function () { setTimeout(sweep, 60); });
    setTimeout(sweep, 1500);                   // 2. po przesunieciach ukladu
    setTimeout(revealAll, 4000);               // 3. twardy limit
  }

  /* ---------- wideo ----------
     Petla bez dzwieku ma NIE startowac, gdy uzytkownik prosil system
     o ograniczenie ruchu. Sam atrybut autoplay tego nie sprawdza, a film
     lecacy w kolko jest dokladnie tym, co to ustawienie ma wylaczac.
     Zostaje pierwsza klatka i kontrolki, wiec material dalej jest dostepny —
     tylko na zadanie. */
  function initVideo(vid) {
    if (!reduceMotion) return;
    try {
      vid.autoplay = false;
      vid.loop = false;
      vid.controls = true;
      vid.pause();
    } catch (err) {
      /* nic: lepiej zostawic film grajacy niz wysypac reszte skryptu */
    }
  }

  /* ---------- montaz ---------- */
  function boot() {
    initTop();
    Drawer.mount();
    document.querySelectorAll("[data-stage]").forEach(initStage);
    document.querySelectorAll("[data-hero]").forEach(initHero);
    // Jawna funkcja, a nie samo initLoop: forEach podaje drugim argumentem
    // INDEKS, ktory trafilby na parametr `always` i kazdy rzad poza pierwszym
    // zapetlalby sie takze na biurku.
    document.querySelectorAll("[data-loop]").forEach(function (el) { initLoop(el); });
    document.querySelectorAll("[data-product]").forEach(initProduct);
    document.querySelectorAll(".rev").forEach(initRev);
    document.querySelectorAll("[data-bar]").forEach(initBar);
    document.querySelectorAll("[data-buy-form]").forEach(bindQuickAdd);
    document.querySelectorAll("[data-how-loop] video").forEach(initVideo);
    initCart();
    initRise();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
